import Hashids from 'hashids';
const salt = process.env.REACT_APP_HASHIDS_SALT;
const hashids = new Hashids(salt)

export const encode = (id: number) : string => {
    return  hashids.encode(id);
}

export const decode  = (text: string) : number => {
    return Number(hashids.decode(text)[0]);
}